/**
 * Admin-side surface of the SHARED transaction-comment tag origin.
 *
 * The `[verb:id/modifier] text` grammar + the per-verb render metadata now live
 * in ONE place — `admin/docker/admin-extras/tx-tags.js` — loaded by both the
 * injected kiosk overrides (as `window.TxTags`) and this admin build (imported
 * by relative path; the `fs.allow` in web/vite.config.ts lets Vite reach it,
 * and `tx-tags.d.ts` beside the JS supplies the types). This module just
 * re-exports it under the admin's existing names so call sites (e.g.
 * UserTransactionsList) stay unchanged. Backend mirror:
 * `app/strichliste/comment_tags.py` (kept in lock-step across the Python/JS
 * boundary).
 *
 * `TX_VERB_META` now also covers the `voucher` / `voucher_sweep` verbs, so the
 * admin badges them instead of rendering the raw tag.
 */
import TxTags, { type TxTag } from "../../../docker/admin-extras/tx-tags.js";

export type { TxTag };

export const parseTxComment = TxTags.parse;
export const TX_VERB_META = TxTags.VERB_META;
